<template>
  <div>
    <div class="loans">
      <div class="part-one">
        <div class="base-title">
          <div class="part-one-content">
            <img class="part-one-title-img" src="../assets/imgs/craft/part-1-title.png" alt="" />
            <div class="part-text part-one-text">
              为吸引集聚更多的优秀青年人才来蓉创新就业，按照“人才新政3.0版”，对我市新引进的取得硕士研究生学历学位的应届毕业生给予生活补贴。
            </div>
          </div>
        </div>
      </div>
      <div class="part-two">
        <img src="../assets/imgs/loans/title1.png" class="part-two-title-img" />
        <div class="part-text">
          全市新引进的取得硕士研究生学历学位的应届毕业生。
        </div>
      </div>
      <div class="part-three">
        <img src="../assets/imgs/21/title2.png" class="part-two-title-img" />
        <div style="
                      background-color: #fff;
                      padding: 0.25rem;
                      border-radius: 10px;
                  " class="part-text">
          符合条件的应届硕士毕业生，可向用人单位所在区（市）县申请不低于3万元生活补贴。
        </div>
      </div>
      <div class="part-two" style="padding: 0; padding-top: 1.6rem; padding-bottom: 0.35rem">
        <img src="../assets/imgs/21/title3.png" class="part-two-title-img" />
        <div class="call">
          <div class="part-text"
            style="width:3.06rem;height:0.55rem;display:flex;align-items:center;justify-content: center;flex-direction:column"
            v-for="(item, index) in callList" :key="index"><a :href="'tel:' + item" style="font-weight:normal">{{
              item }}</a></div>
        </div>
      </div>
      <!-- 咨询 -->
    </div>
    <call></call>
  </div>
</template>

<script>
import call from '../components/call.vue'
export default {
  name: "craft",
  components: {
    call
  },
  data() {
    return {
      callList: [
        "028-68773465",
        "028-81337655",
        "028-62078640",
        "028-86624369",
        "028-86269217",
        "028-87705725",
        "028-85073287",
        "028-84310100",
        "028-84851306",
        "028-83617700",
        "028-89399625",
        "028-82668986",
        "028-85815009",
        "028-87862090",
        "028-82593582",
        "028-27098932",
        "028-89741025",
        "028-83460788",
        "028-88792130",
        "028-82215255",
        "028-84921510",
        "028-88266780",
        "028-88524685",
      ],
    };
  },
  created() { },
  mounted() { },
  computed: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.loans {
  background: #0839b7;
  overflow: hidden;
  padding: 0.24rem 0.12rem;
  padding-bottom: 1.65rem;
  box-sizing: border-box;
  width: 100vw;
  height: 100vh;
  overflow-y: auto;

  .part-title {
    font-size: 0.34rem;
    //font-family:: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    color: #333333;
    position: relative;

    &::before {
      position: absolute;
      content: "";
      width: 0.28rem;
      height: 0.28rem;
      border-radius: 50%;
      background: none;
      border: 0.06rem solid #ff6d60;
      box-sizing: border-box;
      top: 0.08rem;
      left: -0.2rem;
    }
  }

  .part-text {
    font-size: 0.26rem;
    //font-family:: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #4e4e4e;
    line-height: 0.44rem;
    text-align: left;
  }

  .part-one {
    height: 6.88rem;
    width: 7.5rem;
    margin: 0 auto;
    box-sizing: border-box;

    .base-title {
      width: 7.26rem;
      height: 5.6rem;
      background: url(../assets/imgs/21/base-title.png);
      background-size: 100% 100%;
      position: relative;

      .part-one-content {
        width: 6.85rem;
        background: #ffffff;
        border-radius: 10px;
        position: absolute;
        top: 4.02rem;
        left: 50%;
        transform: translateX(-50%);
        padding-left: 0.36rem;
        padding-right: 0.37rem;
        padding-bottom: 0.35rem;
        box-sizing: border-box;

        .part-one-title-img {
          position: absolute;
          top: -0.32rem;
          left: 0;
          width: 6.86rem;
          height: 1.12rem;
        }

        .part-one-title {
          margin-top: 0.98rem;
          text-align: left;
          margin-left: 0.34rem;
        }

        .part-one-text {
          margin-top: 1.12rem;
        }
      }
    }
  }

  .part-two-title-img {
    width: 7.03rem;
    height: 1.37rem;
    top: 0;
    left: -0.18rem;
    position: absolute;
  }

  .part-three-items-img {
    position: absolute;
    width: 2.98rem;
    height: 0.67rem;
    left: 50%;
    transform: translateX(-50%);
    top: -0.32rem;
  }

  .part-two {
    margin-left: 0.02rem;
    width: 6.85rem;
    margin-top: 0.22rem;
    background: #fff;
    border-radius: 10px;
    padding-left: 0.53rem;
    padding-right: 0.3rem;
    box-sizing: border-box;
    margin: 0 auto;
    margin-top: 0.22rem;
    border: 0.00001px solid transparent;
    position: relative;
    padding-top: 1.5rem;
    padding-bottom: 0.35rem;
  }

  .part-three {
    margin-left: 0.02rem;
    width: 6.85rem;
    margin-top: 0.22rem;
    background: #e8eeff;
    border-radius: 10px;
    box-sizing: border-box;
    display: inline-block;
    position: relative;
    padding: 0 0.3rem 0.35rem 0.3rem;
    padding-top: 1.5rem;
  }

  .call {
    width: 6.45rem;
    height: 13.18rem;
    background: url(../assets/imgs/21/call.png);
    background-size: 100% 100%;
    margin: 0 auto;
    padding-left: 3.39rem;
    box-sizing: border-box;
    padding-top: 0.67rem;
  }
}
</style>
